document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.band__comparaison_accordion_name').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
            target.preventDefault();
            if( target.target.closest('.band__comparaison_accordion_tab').classList.contains('active') ){
                target.target.closest('.band__comparaison_accordion_tab').classList.remove('active');
                target.target.closest('.band__comparaison_accordion_tab').querySelector('.band__comparaison_accordion_content').style.maxHeight = null;
            }else{
                document.querySelectorAll('.band__comparaison_accordion_tab').forEach((elm)=>{ elm.classList.remove('active'); elm.querySelector('.band__comparaison_accordion_content').style.maxHeight = null; });
                target.target.closest('.band__comparaison_accordion_tab').classList.add('active');
                let mainTabContent = target.target.closest('.band__comparaison_accordion_tab').querySelector('.band__comparaison_accordion_content');
                mainTabContent.style.maxHeight = `${mainTabContent.scrollHeight}px`;            
            }

            setTimeout(()=>{
                window.scrollTo({
                top: document.querySelector('.band__comparaison_content_lyt').offsetTop - 158,
                behavior: 'smooth'
                });          
            },100)
        
        })
    })
})